<div class="root-container" *ngIf="!isError&& !loading">    
    <div class="title-container">
        <h1 class="h1-title">
            Confirma los datos
        </h1>

        <p class="p-subtitle">
            Revisa que tus datos personales y bancarios sean correctos
        </p>
    </div>

    <div>
        <ion-list class="i-list">
            <ion-item-group class="i-item-group">
                <ion-item-divider class="item-divider">
                    <ion-label class="i-label-title">
                        <h3 class="h3-title">
                            Datos personales
                        </h3>
                    </ion-label>
                </ion-item-divider>

                <ion-item lines="full">
                    <ion-label slot="start" class="i-label-400 m-inline-end-none" style="margin:0; overflow-wrap: anywhere;">Correo:</ion-label>
                    <ion-label slot="end" class="i-label-700 t-align-end m-inline-start-lg label-derecho" [class.sinRegistro]="!email" style="margin:0">
                        {{email || 'Aún no registras tu correo'}}
                    </ion-label>
                </ion-item>
                <ion-item lines="none" class="ion-no-padding">
                    <ion-label slot="start" class="i-label-400 m-inline-end-none" style="margin:0">Teléfono móvil:</ion-label>
                    <ion-label slot="end" class="i-label-700 t-align-end m-inline-start-lg label-derecho" [class.sinRegistro]="!celular" style="margin:0">
                        {{ (celular | formatPhoneNumber) || 'Aún no registras tu teléfono'}}
                    </ion-label>
                </ion-item>
            </ion-item-group>

            <ion-item-group class="i-item-group">
                <ion-item-divider class="item-divider">
                    <ion-label class="i-label-title">
                        <h3 class="h3-title">
                            Datos bancarios
                        </h3>
                    </ion-label>
                </ion-item-divider>

                <ion-item lines="full">
                    <ion-label slot="start" class="i-label-400 m-inline-end-none" style="margin:0">Banco:</ion-label>
                    <ion-label slot="end" class="i-label-700 t-align-end m-inline-start-lg label-derecho" style="margin:0">
                        {{cuentaBancariaSeleccionada.descripcionBanco}}
                    </ion-label>
                </ion-item>
                <ion-item lines="full" class="ion-no-padding">
                    <ion-label slot="start" class="i-label-400 m-inline-end-none" style="margin:0">Tipo de cuenta:</ion-label>
                    <ion-label slot="end" class="i-label-700 t-align-end m-inline-start-lg label-derecho" style="margin:0">
                        {{cuentaBancariaSeleccionada.descripcionTipoCuenta}}
                    </ion-label>
                </ion-item>
                <ion-item lines="none" class="ion-no-padding">
                    <ion-label slot="start" class="i-label-400 m-inline-end-none" style="margin:0">Nº de cuenta:</ion-label>
                    <ion-label slot="end" class="i-label-700 t-align-end m-inline-start-lg label-derecho" style="margin:0">
                        {{cuentaBancariaSeleccionada.numeroCuenta}}
                    </ion-label>
                </ion-item>
            </ion-item-group>
        </ion-list>
    </div>

    <div class="action-container action-container-personalizado">
        <button class="b-btn s-button" (click)="exit()">Salir</button>
        <button [disabled]="attempt" class="b-btn p-button" (click)="gotoComprobante()">
            Confirmar
            <ion-spinner name="crescent" slot="end" *ngIf="attempt; else noLoading" color="light"></ion-spinner>
            <ng-template #noLoading>
                <ion-icon name="arrow-forward-outline"></ion-icon>
            </ng-template>
        </button>
    </div>
</div>


<!-- SKELETON -->
<div class="root-container" *ngIf="!isError && loading">    
    <div class="title-container">
        <ion-skeleton-text
        animated
        style="width: 100%; height: 30px; border-radius: 12px"
      ></ion-skeleton-text>

      <ion-skeleton-text
      animated
      style="width: 100%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>
    </div>

    <div>
        <ion-list class="i-list">
            <ion-item-group class="i-item-group">
                <ion-item-divider class="item-divider">
                    <ion-label class="i-label-title">
                        <ion-skeleton-text
                        animated
                        style="width: 100%; height: 30px; border-radius: 12px"
                      ></ion-skeleton-text>
                    </ion-label>
                </ion-item-divider>

                <ion-item lines="full">
                    <ion-skeleton-text
                    animated
                    style="width: 100%; height: 30px; border-radius: 12px"
                  ></ion-skeleton-text>
                </ion-item>
                <ion-item lines="none" class="ion-no-padding">
                    <ion-skeleton-text
                    animated
                    style="width: 100%; height: 30px; border-radius: 12px"
                  ></ion-skeleton-text>
                </ion-item>
            </ion-item-group>

            <ion-item-group class="i-item-group">
                <ion-item-divider class="item-divider">
                    <ion-skeleton-text
                    animated
                    style="width: 100%; height: 30px; border-radius: 12px"
                    ></ion-skeleton-text>
                </ion-item-divider>

                <ion-item lines="full">
                    <ion-skeleton-text
                    animated
                    style="width: 100%; height: 30px; border-radius: 12px"
                    ></ion-skeleton-text>
                </ion-item>
                <ion-item lines="full" class="ion-no-padding">
                    <ion-skeleton-text
                    animated
                    style="width: 100%; height: 30px; border-radius: 12px"
                    ></ion-skeleton-text>
                </ion-item>
                <ion-item lines="none" class="ion-no-padding">
                    <ion-skeleton-text
                    animated
                    style="width: 100%; height: 30px; border-radius: 12px"
                  ></ion-skeleton-text>
                </ion-item>
            </ion-item-group>
        </ion-list>
    </div>

    <div class="action-container action-container-personalizado">
        <ion-skeleton-text
        animated
        style="width: 100%; height: 30px; border-radius: 12px"
      ></ion-skeleton-text>
    </div>
</div>


